// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-down-button-container-YF57d {
  height: 32px;
  display: flex;
  cursor: pointer;
}

.drop-down-button-button-mBaZC {
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--color-neutral-300);
  border-radius: 6px 0px 0px 6px;
  padding-left: 8px;
}

.drop-down-button-button-mBaZC:hover, .drop-down-button-button-mBaZC:hover ~ .drop-down-button-iconRight-woBdM {
  background-color: var(--hover-color);
}

.drop-down-button-button-mBaZC:active, .drop-down-button-button-mBaZC:active ~ .drop-down-button-iconRight-woBdM {
  background-color: var(--active-color);
}

.drop-down-button-title-kzYea {
  line-height: 32px;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin: 0px 12px 0px 8px;
  white-space: nowrap;
}

.drop-down-button-icon-fd04w {
  --size: 20px;
  color: var(--color-neutral-700);
}

.drop-down-button-iconRight-woBdM {
  width: 28px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  color: var(--color-neutral-700);
  border: 1px solid var(--color-neutral-300);
  border-left: none;
  border-radius: 0px 6px 6px 0px;
  transition: background-color 100ms;
}

.drop-down-button-iconRight-woBdM:hover {
  background-color: var(--hover-color);
}

.drop-down-button-iconRight-woBdM:active {
  background-color: var(--active-color);
}

.drop-down-button-menu_container-tM08P {
  width: unset;
  min-width: 232px;
}
`, "",{"version":3,"sources":["webpack://./src/components/drop-down-button/drop-down-button.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".container {\n  height: 32px;\n  display: flex;\n  cursor: pointer;\n}\n\n.button {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: 6px 0px 0px 6px;\n  padding-left: 8px;\n}\n\n.button:hover, .button:hover ~ .iconRight {\n  background-color: var(--hover-color);\n}\n\n.button:active, .button:active ~ .iconRight {\n  background-color: var(--active-color);\n}\n\n.title {\n  line-height: 32px;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin: 0px 12px 0px 8px;\n  white-space: nowrap;\n}\n\n.icon {\n  --size: 20px;\n  color: var(--color-neutral-700);\n}\n\n.iconRight {\n  width: 28px;\n  height: 32px;\n  line-height: 32px;\n  text-align: center;\n  font-size: 20px;\n  color: var(--color-neutral-700);\n  border: 1px solid var(--color-neutral-300);\n  border-left: none;\n  border-radius: 0px 6px 6px 0px;\n  transition: background-color 100ms;\n}\n\n.iconRight:hover {\n  background-color: var(--hover-color);\n}\n\n.iconRight:active {\n  background-color: var(--active-color);\n}\n\n.menu_container {\n  width: unset;\n  min-width: 232px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `drop-down-button-container-YF57d`,
	"button": `drop-down-button-button-mBaZC`,
	"iconRight": `drop-down-button-iconRight-woBdM`,
	"title": `drop-down-button-title-kzYea`,
	"icon": `drop-down-button-icon-fd04w`,
	"menu_container": `drop-down-button-menu_container-tM08P`
};
export default ___CSS_LOADER_EXPORT___;
